import { IRoutesConfig } from "../appRoutesConfig";
import { pageRoutes } from "../routes";
import React from "react";

const panelRoutesConfig: IRoutesConfig = {
  auth: [],
  path: pageRoutes.PANEL,
  layout: React.lazy(() => import("./layout")),
  routes: [
    {
      auth: [],
      component: React.lazy(() => import("./dashboard")),
      title: "Dashboard",
      path: pageRoutes.DASHBOARD,
    },
    {
      auth: [],
      component: React.lazy(() => import("./meetingRequest")),
      title: "Meeting Request",
      path: pageRoutes.MEETING_REQUEST,
    },
    {
      auth: [],
      component: React.lazy(() => import("./groupTherapy")),
      title: "Group Therapy",
      path: pageRoutes.GROUP_THERAPY,
    },
    {
      auth: [],
      component: React.lazy(() => import("./groupTherapy/GroupTherapyReserve")),
      title: "Group Therapy Request",
      path: pageRoutes.GROUP_THERAPY_REQUEST,
    },
    {
      auth: [],
      component: React.lazy(() => import("./meetingHistory")),
      title: "Meeting History",
      path: pageRoutes.MEETING_HISTORY,
    },
    {
      auth: [],
      component: React.lazy(() => import("./groupTherapyHistory")),
      title: "Group Therapy History",
      path: pageRoutes.GROUP_THERAPY_HISTORY,
    },
    {
      auth: [],
      component: React.lazy(() => import("./purchaseHistory")),
      title: "Purchase History",
      path: pageRoutes.PURCHASE_HISTORY,
    },
    {
      auth: [],
      component: React.lazy(() => import("./messages")),
      title: "Messages",
      path: pageRoutes.MESSAGES,
    },
    {
      auth: [],
      component: React.lazy(() => import("./profile")),
      title: "Profile",
      path: pageRoutes.PROFILE,
    },
    {
      auth: [],
      component: React.lazy(() => import("./userManagement")),
      title: "user management",
      path: pageRoutes.USER_MANAGEMENT,
    },
    {
      auth: [],
      component: React.lazy(() => import("./calendar")),
      title: "Calendar",
      path: pageRoutes.CALENDAR,
    },
    {
      auth: [],
      component: React.lazy(() => import("./termsOfServices")),
      title: "Terms Of Services",
      path: pageRoutes.TERMS_OF_SERVICES,
    },
    {
      auth: [],
      component: React.lazy(() => import("./termsOfServicesGroupTherapy")),
      title: "Terms Of Services Group Therapy",
      path: pageRoutes.TERMS_OF_SERVICES_GROUP_THERAPY,
    },
    {
      auth: [],
      component: React.lazy(() => import("./emails")),
      title: "Emails",
      path: pageRoutes.EMAILS,
    },
    {
      auth: [],
      component: React.lazy(() => import("./admin")),
      title: "Admin",
      path: pageRoutes.ADMIN,
    },
  ],
};

export { panelRoutesConfig };
